import React from 'react';
import { History, Clock, ChevronUp, ChevronDown, Trash2 } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../components/ui/card';
import { Badge } from '../../../components/ui/badge';
import { Button } from '../../../components/ui/button';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '../../../components/ui/collapsible';

export const ProductImportHistory = ({ importHistory, showImportHistory, setShowImportHistory, loadImportHistory, handleClearImportHistory }) => (
    <Card className="mb-6 border-0 bg-white/80 backdrop-blur-sm shadow-sm rounded-2xl" data-testid="supplier-import-history">
        <Collapsible open={showImportHistory} onOpenChange={(open) => { setShowImportHistory(open); if (open && importHistory.length === 0) loadImportHistory(); }}>
            <CollapsibleTrigger asChild>
                <CardHeader className="cursor-pointer hover:bg-jungle/5 rounded-t-2xl transition-colors">
                    <CardTitle className="font-heading text-jungle flex items-center justify-between">
                        <div className="flex items-center gap-2">
                            <History className="w-5 h-5 text-orange-500" />
                            Historique des imports fournisseur
                        </div>
                        {showImportHistory ? <ChevronUp className="w-5 h-5" /> : <ChevronDown className="w-5 h-5" />}
                    </CardTitle>
                </CardHeader>
            </CollapsibleTrigger>
            <CollapsibleContent>
                <CardContent>
                    {importHistory.length > 0 ? (
                        <>
                            <div className="flex justify-end mb-3">
                                <Button size="sm" variant="outline" className="text-red-500 border-red-300 hover:bg-red-50 rounded-xl" onClick={handleClearImportHistory} data-testid="clear-import-history">
                                    <Trash2 className="w-3 h-3 mr-1" /> Effacer l'historique
                                </Button>
                            </div>
                            <div className="space-y-3">
                                {importHistory.map((imp) => (
                                    <div key={imp.id} className="flex flex-col sm:flex-row sm:items-center justify-between p-4 rounded-xl bg-orange-50/50 border border-orange-100 gap-2">
                                        <div className="flex-1 min-w-0">
                                            <div className="flex items-center gap-2 flex-wrap">
                                                <Clock className="w-4 h-4 text-orange-500 shrink-0" />
                                                <span className="text-sm font-medium text-jungle">
                                                    {new Date(imp.imported_at).toLocaleDateString('fr-FR', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })}
                                                </span>
                                                <span className="text-xs text-muted-foreground truncate">{imp.filename}</span>
                                            </div>
                                            <div className="flex items-center gap-3 mt-1 text-xs flex-wrap">
                                                <span className="text-muted-foreground">par {imp.imported_by}</span>
                                                {imp.products_created > 0 && (
                                                    <Badge variant="outline" className="rounded-full text-emerald-600 border-emerald-300 text-xs">+{imp.products_created} cree(s)</Badge>
                                                )}
                                                {imp.products_updated > 0 && (
                                                    <Badge variant="outline" className="rounded-full text-blue-600 border-blue-300 text-xs">{imp.products_updated} mis a jour</Badge>
                                                )}
                                                {imp.errors_count > 0 && (
                                                    <Badge variant="outline" className="rounded-full text-red-600 border-red-300 text-xs">{imp.errors_count} erreur(s)</Badge>
                                                )}
                                                {imp.products_skipped > 0 && (
                                                    <Badge variant="outline" className="rounded-full text-muted-foreground text-xs">{imp.products_skipped} ignore(s)</Badge>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </>
                    ) : (
                        <p className="text-sm text-muted-foreground text-center py-4">Aucun import fournisseur enregistre</p>
                    )}
                </CardContent>
            </CollapsibleContent>
        </Collapsible>
    </Card>
);
